<script>
    import SkillKnob from './SkillKnob.svelte'
    export let value = 0;
</script>

<div class="w-full flex-1">
    <div class="px-24 md:px-36 lg:px-40">
        <SkillKnob value="{value}" />
    </div>
    <p class="font-medium text-xl font-semibold text-center">
        <slot />
    </p>
</div>
